import { Component, ComponentRef, EventEmitter as AngularEventEmitter, OnInit, Output, Type, ViewChild, ViewContainerRef, ViewRef } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { FileModel } from 'app/views/presentations/models/file.model';
import { Section } from 'app/views/presentations/models/presentation.model';
import { SectionContent } from 'app/views/presentations/models/sectionContent.model';
import { WidgetComponent } from 'app/views/presentations/widgets/widget.component';
import { WidgetResolver } from 'app/views/presentations/widgets/widgetResolver';
import { EventEmitter } from 'events';
import { Observable } from 'rxjs';

@Component({
    selector: 'psm-widget-selector',
    templateUrl: 'widgetSelector.component.html'
})
export class WidgetSelectorComponent {
    private static readonly contentChangedEventName = 'ContentChanged';

    public supportedWidgetKeys: string[];
    private contentObservable: Observable<Section>;

    private editorComponent: WidgetComponent;
    public get content(): any { return this.editorComponent ? this.editorComponent.content : undefined; }
    public get files(): FileModel[] { return this.editorComponent ? this.editorComponent.files : undefined; }
    public getFormControls(): Promise<AbstractControl[]> { return this.editorComponent ? this.editorComponent.getFormControls() : Promise.resolve([]); }
    public type: string;
    private editorBackups: Map<string, { content: any, files: FileModel[] }> = new Map();

    @ViewChild('editor', { read: ViewContainerRef }) private editorContainer: ViewContainerRef;

    @Output()
    private sectionChanged: AngularEventEmitter<Section> = new AngularEventEmitter<Section>();

    public contentChanged: EventEmitter = new EventEmitter();

    constructor(private resolver: WidgetResolver) {
        this.supportedWidgetKeys = resolver.getSupportedComponentKeys();
    }

    public clearBackups() {
        this.editorBackups = new Map();
    }

    public async changeEditor(type: string, content?: any, files?: FileModel[], forceNoBackup: boolean = false) {

        // Backup current editor changes
        if (this.type && !forceNoBackup) {
            this.editorBackups.set(this.type, { content: this.content, files: this.files });
        }

        this.clearEditor();
        this.type = type;

        if (!type) {
            this.contentChanged.emit(WidgetComponent.contentChangedEventName);
            return;
        }

        let factory = this.resolver.resolveComponent(type);
        this.editorComponent = this.editorContainer.createComponent(factory).instance;

        // Restore editor backup if its possible
        if (this.editorBackups.has(this.type)) {
            let backup = this.editorBackups.get(this.type);
            this.editorComponent.content = backup.content;
            this.editorComponent.files = backup.files;
        } else {
            this.editorComponent.content = content;
            this.editorComponent.files = files;
        }

        await this.editorComponent.initialize();
        this.editorComponent.contentChanged.addListener(WidgetComponent.contentChangedEventName, () => {
            this.contentChanged.emit(WidgetComponent.contentChangedEventName);
        });

        this.contentChanged.emit(WidgetComponent.contentChangedEventName);
    }

    public clearEditor() {
        if (this.editorComponent !== undefined) {
            this.editorComponent.contentChanged.removeAllListeners();
        }

        this.type = undefined;
        this.editorComponent = undefined;
        this.editorContainer.clear();
    }

    public getSection(): Observable<Section> {
        return new Observable<Section>(observable => {
            const onContentChanged = async () => {
                let controls = await this.getFormControls();
                let section = new Section(this.type, this.content, this.files, controls);
                observable.next(section);
                this.sectionChanged.emit(section);
            };

            onContentChanged().then(controls => {
                this.contentChanged.addListener(WidgetSelectorComponent.contentChangedEventName, onContentChanged);
                observable.add(() => {
                    this.contentChanged.removeListener(WidgetSelectorComponent.contentChangedEventName, onContentChanged);
                });
            });
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/views/presentations/widgets/widgetSelector.component.ts